import { constObjectGenerator } from "../../../../../common/utils/utilsEx";

export interface IScreenLockerState {
    lockedOn?: number;
    locks: string[];
}

export const screenLockerAT = constObjectGenerator(
    ["lock", "unlock"],
    "{key}/ScreenLocker"
);
